import { useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import { SignInButton } from '@clerk/clerk-react';
import { Button } from '../input';
import { useGlobal } from '../../state';

export const FFSignInWrapper = ({ children, ...props }) => {
  const { user } = useGlobal();

  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  if (user) {
    return children;
  }

  return (
    <SignInButton
      mode="modal"
      afterSignInUrl="/?s=1"
      signUpFallbackRedirectUrl={props.signUpFallbackRedirectUrl || currentUrl}
      signInFallbackRedirectUrl={props.signInFallbackRedirectUrl || currentUrl}
      fallbackRedirectUrl={props.fallbackRedirectUrl || currentUrl}
    >
      {children}
    </SignInButton>
  );
};

export const FFSignInButton = ({ children, onClick, ...props }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
      Cookies.set('handleUrl', window.location.href);
    }
  }, []);

  return (
    <SignInButton
      mode="modal"
      forceRedirectUrl="/handle"
      signUpFallbackRedirectUrl={props.signUpFallbackRedirectUrl || '/handle'}
      signInFallbackRedirectUrl={props.signInFallbackRedirectUrl || '/handle'}
      fallbackRedirectUrl={props.fallbackRedirectUrl || currentUrl}
    >
      <Button style={{ width: '100%', ...(props.style || {}) }} {...props} onClick={onClick}>
        {children || 'Sign In'}
      </Button>
    </SignInButton>
  );
};
